const libraries = ["places", "drawing"];

export default libraries;
